import type { Editor } from '@tiptap/react';
import { type MouseEvent, useRef } from 'react';

interface EditorFocusReturn {
  returnFocusToEditorOnClose: () => void;
  finalFocus: () => boolean;
}

export const keepEditorFocus = (event: MouseEvent) => {
  event.preventDefault();
};

export const useEditorFocusReturn = (editor: Editor): EditorFocusReturn => {
  const returnsToEditorRef = useRef<boolean>(false);

  const returnFocusToEditorOnClose = () => {
    returnsToEditorRef.current = true;
  };

  const finalFocus = (): boolean => {
    if (!returnsToEditorRef.current) {
      return true;
    }
    returnsToEditorRef.current = false;
    editor.commands.focus();
    return false;
  };

  return { returnFocusToEditorOnClose, finalFocus };
};
